import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

    constructor(
        public router: Router,
    ) {
        console.log(this.router.url);
        if (this.router.url === '/vcalling') {
            this.router.navigateByUrl('vcalling-lead-management-system');
        }
    }

    ngOnInit() {
    }

}
